import React, { useState, useEffect } from 'react';
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Button } from "react-bootstrap";

const MultiplierDialog = (props) => {
    const { onClose, value: valueProp, open, ...other } = props;
    const [value, setValue] = useState(valueProp);

    // Generate multiplier options from 1 to 10
    const multiplierOptions = Array.from({ length: 10 }, (_, i) => ({
        id: i + 1,
        multiplier: (i + 1)?.toString()
    }));

    useEffect(() => {
        if (!open) {
            setValue(valueProp);
        }
    }, [valueProp, open]);

    const handleCancel = () => {
        onClose();
    };

    const handleOk = () => {
        onClose(value);
    };

    const handleChange = (event) => {
        setValue(event.target.value);
    };

    return (
        <Dialog
            sx={{ "& .MuiDialog-paper": { width: "80%", maxHeight: 435 } }}
            maxWidth="xs"
            open={open}
            {...other}
        >
            <DialogTitle>Update User play</DialogTitle>
            <DialogContent dividers>
                <RadioGroup
                    aria-label="multiplier"
                    name="play"
                    value={value}
                    onChange={handleChange}
                >
                    {multiplierOptions.map((option) => (
                        <FormControlLabel
                            value={option?.multiplier}
                            key={option?.id}
                            control={<Radio />}
                            label={`${option?.multiplier}x`}
                        />
                    ))}
                    {/* play */}
                </RadioGroup>
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={handleCancel}>
                    Cancel
                </Button>
                <Button onClick={handleOk}>Update</Button>
            </DialogActions>
        </Dialog>
    );
};

export default MultiplierDialog;